import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

const DEMO_WALLETS = [
  {
    id: 1,
    user_id: 42,
    name: 'Paper Trading Wallet',
    wallet_type: 'PAPER',
    is_active: true,
    created_at: '2026-01-15T10:00:00Z',
    updated_at: '2026-03-08T16:45:00Z',
  },
  {
    id: 2,
    user_id: 42,
    name: 'Live Wallet (Locked)',
    wallet_type: 'LIVE',
    is_active: false,
    created_at: '2026-02-01T14:00:00Z',
    updated_at: '2026-02-01T14:00:00Z',
  },
];

export const demoWalletsHandlers = [
  // ── List wallets ──────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/wallets`, () => {
    return HttpResponse.json({
      items: DEMO_WALLETS,
      total: DEMO_WALLETS.length,
      limit: 50,
      offset: 0,
    });
  }),

  // ── Wallet balances ───────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/wallets/:id/balances`, () => {
    return HttpResponse.json({
      balances: [
        { asset: 'USDT', amount: '10000.00' },
        { asset: 'BTC', amount: '0.50000000' },
        { asset: 'ETH', amount: '5.20000000' },
        { asset: 'SOL', amount: '120.00000000' },
      ],
    });
  }),

  // ── Paper wallet top-up ───────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/wallets/paper/top-up/:id`, () => {
    return HttpResponse.json({ success: true });
  }),

  // ── Paper wallet reset ────────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/wallets/paper/reset/:id`, () => {
    return HttpResponse.json({ success: true });
  }),
];
